import React from 'react';
import SamuraiGame from '../SamuraiGame';

const OneOneTwoOneOneDrill = () => {
    return <SamuraiGame initialDrillIndex={8} />;
};

export default OneOneTwoOneOneDrill;
